<style lang="scss" scoped>
.day-configurator-body {
    //full viewport height minus the height of the header (65px)
    height: calc(100vh - 65px);
    height: calc(var(--vh, 1vh) * 100 - 65px);
}
</style>

<template>
    <div class="day-configurator-body d-flex">
        <day-configurator-practical-details
            v-if="canEdit"
            :items="items"
            :loading-google-location="loadingGoogleLocation"
            @next-step="changeStep('planning')"
            @previous-step="changeStep('practical-details')"
        ></day-configurator-practical-details>
        <day-configurator-planning
            @previous-step="changeStep('practical-details')"
            :items="items"
        ></day-configurator-planning>
        <day-configurator-side-panel
            v-if="canEdit"
            :class="{ active: activeStep === 'request-offer' }"
            @previous-step="changeStep('planning')"
        ></day-configurator-side-panel>
    </div>
</template>

<script>
import { bus } from "@/app";
import core from "./day-configurator-core";
import FormatModal from "./modals/day-configurator-format-modal";

export default {
    mixins: [core],

    props: {
        initialStep: {
            type: String,
            required: false
        }
    },

    data: () => ({
        activeStep: "practical-details",
        items: {
            activity: [],
            speaker: [],
            location: [],
            staticItem: [],
            gift: []
        },
        loadingGoogleLocation: false
    }),

    created() {
        if (this.initialStep) {
            this.activeStep = this.initialStep;
        } else {
            if (window.location.hash !== "#nieuw") {
                this.showFormatPopup();
            }
        }

        bus.$on("changeStep", step => {
            this.activeStep = step;
        });
    },

    mounted() {
        const self = this;

        axios.get("/api/all-items").then(response => {
            this.items.activity = response.data.filter(
                item => item.post_type == "activities"
            );
            this.items.speaker = response.data.filter(
                item => item.post_type == "speakers"
            );
            this.items.location = response.data.filter(
                item => item.post_type == "locations"
            );
            this.items.gift = response.data.filter(
                item =>
                    item.post_type == "gifts" || item.post_type == "tribe-box"
            );
        });

        if (
            this.schedule.location &&
            this.schedule.location_type === "GOOGLE_MAPS"
        ) {
            this.loadingGoogleLocation = true;
            this.prefillLocationField(this.schedule.location).then(location => {
                this.loadingGoogleLocation = false;                
            });
        } else if (
            this.schedule.location &&
            this.schedule.location_type === "WORDPRESS"
        ) {
            bus.$emit("addressUpdate", this.schedule.location);
        }

        if (this.isReadOnly) {
            setTimeout(function() {
                self.$toasted.show(
                    self.translations.day_planning.read_only_text,
                    {
                        action: {
                            text: "Sluiten",
                            onClick: (e, toastObject) => {
                                toastObject.goAway(0);
                            }
                        }
                    }
                );
            }, 500);
        }
    },

    methods: {
        changeStep(step) {
            this.activeStep = step;
        },

        showFormatPopup() {
            this.$modal.show(FormatModal, {
                adaptive: true,
                pivotY: this.$root.isMobile ? 1 : 0.5,
                classes: "py-30",
                width: "720",
                height: "auto",
                scrollable: true
            });
        }
    }
};
</script>
